import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable, Subscription, throwError } from 'rxjs';
import { Select } from '@ngxs/store';

import { Deposit } from '../../core/models/deposit.model';
import { DepositService, ToastService } from '../../core/services';
import { catchError, finalize } from 'rxjs/operators';
import { UserProfile } from '../../core/models';

@Component({
    selector: 'gs-deposit-succeeded',
    templateUrl: './deposit-succeeded.component.html',
    standalone: false
})
export class DepositSucceededComponent implements OnInit, OnDestroy {
  @Select(state => state.auth.cartCount) cartCount$: Observable<number>;
  @Select(state => state.auth.user) user$: Observable<UserProfile>;

  deposit: Deposit;
  //  = {
  //   id: 1,
  //   userId: 123,
  //   amount: 1000,
  //   status: 1,
  //   walletStatus: 1,
  //   createdDate: new Date(),
  //   refundDate: null
  // };

  private subscriptions: Subscription[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private depositService: DepositService,
    private toastService: ToastService
  ) {
  }

  ngOnInit() {
    const depositId = this.route.snapshot.paramMap.get('id');
    if (!depositId) {
      this.router.navigate(['/error']);
      return;
    }

    this.getDeposit(depositId);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  private getDeposit(depositId: string) {
    this.subscriptions.push(
      this.depositService.getDeposit(depositId)
        .pipe(
          catchError(e => {
            this.toastService.checkErrorForStatus(e);
            return throwError(e);
          }),
          finalize(() => { })
        )
        .subscribe((response: any) => {
          this.deposit = response;
        })
    );
  }
}
